module.exports = __webpack_public_path__ + "static/media/paragon_3.c6e46d2a.png";